<template>
  <div class="table-extra" id="table-admin-controls">
    <edit-admin
      v-if="showEditForm"
      :show.sync="showEditForm"
      @close="showEditForm = false"
      :item="item"
    />
    <modal
      v-if="showDeleteModal"
      :customerClass="'modal-type-dialog'"
      :show.sync="showDeleteModal"
      @cancel="onHideDelete"
      :large="true"
      :closeIcon="false"
    >
      <div slot="header">
        <h3><b>Delete</b></h3>
      </div>
      <h6>Are you sure? You couldn't restore it back.</h6>
      <div slot="footer">
        <b-button
          class="active btn-ln-md"
          variant="modal"
          @click="onHideDelete"
        >
          No
        </b-button>
        <b-button class="btn-ln-md" variant="modal" @click="onDelete">
          Yes
        </b-button>
      </div>
    </modal>
    <ul class="table-controls">
      <li @click="showEditForm = true">
        <div class="custom-icon pen-icon"></div>
      </li>
      <li @click="onShowDelete">
        <div class="custom-icon delete-icon"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import modal from "../shared/modal";
import editAdmin from "./edit";

export default {
  name: "table-admin-controls",
  components: { modal, editAdmin },
  props: ["item"],
  data() {
    return {
      showDeleteModal: false,
      showEditForm: false
    };
  },
  methods: {
    onShowDelete() {
      this.showDeleteModal = true;
    },
    onHideDelete() {
      this.showDeleteModal = false;
    },
    onDelete() {
      this.$store.dispatch("deleteAdmin", this.item.id);
      this.onHideDelete();
    }
  }
};
</script>
